import { createProvider } from '../vue-apollo'
import { onError } from 'apollo-link-error'
import vm from '@/main'

const UNAUTHENTICATED_CODE = 'UNAUTHENTICATED'

const errorHandler = onError(({ networkError, graphQLErrors }) => {
  if (
    (graphQLErrors[0] &&
      graphQLErrors[0].extensions.code === UNAUTHENTICATED_CODE) ||
    (networkError &&
      networkError.result.errors.some(
        x => x.extensions.code === UNAUTHENTICATED_CODE
      ))
  ) {
    vm.$sso.drop()
    location.reload()
  }
})

export const apolloProvider = createProvider({
  link: errorHandler
})
